import {
  Interswitch,
  KudaIcon,
  MoniepointIcon,
  OpayIcon,
} from "../assets/svgIcons";
import { pathConstants } from "../routes/pathContants";

export const intergratedTerminalInfo = {
  OPAY: {
    primaryName: "Opay",
    secondaryName: "Opay",
    icon: <OpayIcon />,
    hasDynamicAccount: false,
    postEndpoint: "/company/create-opay-account/",
    getEndpoint: "/company/opay-account/",
    getQueryKey: "getOpayAccount",
    fields: [
      // {
      //   step: 0,
      //   name: "ConnectBusiness",
      //   label: "Connect Business",
      //   postEndpoint: "/company/create-opay-account/",
      //   getEndpoint: "/company/opay-account/",
      //   getQueryKey: "getOpayAccount",
      //   removeFields: ["opay_public_key", "client_auth_key"],
      //   route: () => {
      //     return null;
      //   },
      //   fieldList: [
      //     {
      //       key: "client_id",
      //       label: "Client ID",
      //       isRequired: true,
      //     },
      //     {
      //       key: "merchant_name",
      //       label: "Merchant Name",
      //       isRequired: true,
      //     },
      //     {
      //       key: "merchant_industry",
      //       label: "Merchant Industry",
      //       isRequired: true,
      //       fieldType: "SELECT",
      //     },
      //   ],
      // },
      // {
      //   step: 1,
      //   name: "ConnectPublicKeys",
      //   label: "Generate Pubic & Auth Key",
      //   postEndpoint: "/company/create-opay-account/",
      //   getEndpoint: "/company/opay-account/",
      //   getQueryKey: "getOpayAccount",
      //   removeFields: ["client_id", "merchant_name"],
      //   route: () => {
      //     return null;
      //   },
      //   fieldList: [
      //     {
      //       key: "opay_public_key",
      //       label: "Opay Public Key",
      //       isRequired: true,
      //     },
      //     {
      //       key: "client_auth_key",
      //       label: "Client Auth Key",
      //       isRequired: true,
      //     },
      //   ],
      // },
      {
        step: 0,
        name: "ConnectTerminal",
        label: "Add Terminal",
        postEndpoint: "/terminals/create-terminal/",
        getEndpoint: null,
        getQueryKey: "getOpayccount",
        route: (terminalType) => {
          return (
            pathConstants.APPS_INTEGRATION_TERMINALS +
            `?terminal_type=${terminalType}`
          );
        },
        useStaticAccount: false,
        fieldList: [
          // {
          //   key: "merchant_id",
          //   label: "Merchant ID",
          //   isRequired: true,
          // },
          {
            key: "terminal_sn",
            label: "Terminal Serial No",
            isRequired: true,
          },
        ],
      },
    ],
  },

  MONIEPOINT: {
    primaryName: "Moniepoint",
    secondaryName: "Moniepoint",
    icon: <MoniepointIcon />,
    hasDynamicAccount: false,
    postEndpoint: "/company/create-moniepoint-account/",
    getEndpoint: "/company/moniepoint-account/",
    getQueryKey: "getMoniepointAccount",
    fields: [
      {
        step: 0,
        name: "ConnectBusiness",
        label: "Connect Business",
        postEndpoint: "/company/create-moniepoint-account/",
        getEndpoint: "/company/moniepoint-account/",
        getQueryKey: "getMoniepointAccount",
        route: () => {
          return null;
        },
        fieldList: [
          {
            key: "api_key",
            label: "API Key",
            isRequired: true,
          },
          {
            key: "merchant_name",
            label: "Merchant Name",
            isRequired: true,
          },
          {
            key: "webhook_secret",
            label: "Webhook Secret",
            isRequired: false,
          },
        ],
      },
      {
        step: 1,
        name: "ConnectTerminal",
        label: "Add Terminal",
        postEndpoint: "/terminals/create-terminal/",
        getEndpoint: null,
        getQueryKey: "getInterswitchAccount",
        useStaticAccount: true,
        route: (terminalType) => {
          return (
            pathConstants.APPS_INTEGRATION_TERMINALS +
            `?terminal_type=${terminalType}&show_webhook_url=true`
          );
        },
        fieldList: [
          {
            key: "terminal_id",
            label: "Terminal ID",
            isRequired: true,
          },
          {
            key: "terminal_sn",
            label: "Terminal Serial No",
            isRequired: true,
          },
          {
            key: "account_number",
            label: "Account Number",
            isRequired: true,
          },
          {
            key: "account_name",
            label: "Account Name",
            isRequired: true,
          },
        ],
      },
    ],
  },

  INTERSWITCH: {
    primaryName: "Interswitch",
    secondaryName: "Interswitch",
    icon: <Interswitch />,
    hasDynamicAccount: true,
    postEndpoint: "/company/create-interswitch-account/",
    getEndpoint: "/company/interswitch-account/",
    getQueryKey: "getInterswitchAccount",
    fields: [
      // {
      //   step: 0,
      //   name: "ConnectBusiness",
      //   label: "Connect Business",
      //   postEndpoint: "/company/create-interswitch-account/",
      //   getEndpoint: "/company/interswitch-account/",
      //   getQueryKey: "getInterswitchAccount",
      //   route: () => {
      //     return null;
      //   },
      //   fieldList: [
      //     {
      //       key: "client_id",
      //       label: "Client ID",
      //       isRequired: true,
      //     },
      //     {
      //       key: "client_secret",
      //       label: "Client Secret",
      //       isRequired: true,
      //     },
      //     {
      //       key: "merchant_code",
      //       label: "Merchant Code",
      //       isRequired: true,
      //     },
      //     {
      //       key: "merchant_name",
      //       label: "Merchant Name",
      //       isRequired: true,
      //     },
      //     {
      //       key: "webhook_secret",
      //       label: "Webhook Secret",
      //       isRequired: false,
      //     },
      //   ],
      // },
      {
        step: 0,
        name: "ConnectTerminal",
        label: "Add Terminal",
        postEndpoint: "/terminals/create-terminal/",
        getEndpoint: null,
        getQueryKey: "getInterswitchAccount",
        route: (terminalType) => {
          return (
            pathConstants.APPS_INTEGRATION_TERMINALS +
            `?terminal_type=${terminalType}&show_webhook_url=true`
          );
        },
        useStaticAccount: false,
        fieldList: [
          {
            key: "terminal_id",
            label: "Terminal ID",
            isRequired: true,
          },
          {
            key: "terminal_sn",
            label: "Terminal Serial No",
            isRequired: true,
          },
          {
            key: "merchant_id",
            label: "Merchant ID",
            isRequired: true,
          },
        ],
      },
    ],
  },

  KUDA: {
    primaryName: "Kuda",
    secondaryName: "Kuda",
    icon: <KudaIcon />,
    postEndpoint: "/company/create-kuda-account/",
    getEndpoint: null,
    getQueryKey: "getKudaAccount",
    fields: [
      {
        step: 0,
        name: "ConnectTerminal",
        label: "Add Terminal",
        postEndpoint: "/terminals/create-terminal/",
        getEndpoint: null,
        getQueryKey: null,
        route: (terminalType) => {
          return (
            pathConstants.APPS_INTEGRATION_TERMINALS +
            `?terminal_type=${terminalType}`
          );
        },
        useStaticAccount: true,
        fieldList: [
          {
            key: "terminal_id",
            label: "Sell Token",
            isRequired: true,
          },
          {
            key: "account_name",
            label: "Account Name",
            isRequired: true,
          },
          {
            key: "account_number",
            label: "Account Number",
            isRequired: true,
          },
        ],
      },
    ],
  },
};
